import { EmptyPage } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconEmptyPage12Line = createIcon(EmptyPage, 12, "Line");
export const IconEmptyPage16Line = createIcon(EmptyPage, 16, "Line");
export const IconEmptyPage20Line = createIcon(EmptyPage, 20, "Line");
export const IconEmptyPage24Line = createIcon(EmptyPage, 24, "Line");
export const IconEmptyPage32Line = createIcon(EmptyPage, 32, "Line");
export const IconEmptyPage48Line = createIcon(EmptyPage, 48, "Line");
export const IconEmptyPage64Line = createIcon(EmptyPage, 64, "Line");
